import { render, staticRenderFns } from "./LevelRenew4.vue?vue&type=template&id=86bad0ea"
import script from "./LevelRenew4.vue?vue&type=script&lang=js"
export * from "./LevelRenew4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports